import React, {Component} from 'react'

import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'

import FormControl from '@material-ui/core/FormControl'
import InputLabel from '@material-ui/core/InputLabel'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'

import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField'
import { Menu } from '@material-ui/core'


/**
 * onCreateClick(user)
 * onCancelClick
 */

class CreateUserDialog extends Component {

	state = {
		name: "",
		password: "",
		email: "",
		permission: undefined,
	}

	isReadyToCreate() {
		return this.state.name !== "" && this.state.password !== "" && this.state.permission !== undefined
	}

	render() {

		return <Dialog
			open = {true}
			scroll = "body"
		>

			<DialogTitle>
				Создать пользователя
			</DialogTitle>

			<DialogContent style = {{display: "flex", flexDirection: "column"}}>

				<TextField
					value = {this.state.name}
					label = "Имя пользователя"
					margin = "normal"
					onChange = {e => {
						this.setState({
							name: e.target.value
						})
					}}
				/>

				<TextField
					value = {this.state.email}
					label = "Электронная почта"
					margin = "normal"
					onChange = {e => {
						this.setState({
							email: e.target.value
						})
					}}
				/>

				<TextField
					value = {this.state.password}
					type = "password"
					label = "Пароль"
					margin = "normal"
					onChange = {e => {
						this.setState({
							password: e.target.value
						})
					}}
				/>

				<FormControl
					margin = "normal"
				>
					<InputLabel htmlFor="permission">Права доступа</InputLabel>
					<Select
						value={this.state.permission}
						onChange={e => this.setState({permission: e.target.value})}
						inputProps={{
							name: 'permission',
							id: 'permission',
						}}
					>
						{[
							{name: "Никто", value: 0},
							{name: "Ожидает подтверждения", value: 1},
							{name: "Администратор", value: 2},
							{name: "Работник", value: 3},
							{name: "Ведущий", value: 4},
						].map((permission, n) => 
							<MenuItem 
								key={n}
								selected={this.state.permission === permission.value}
								value={permission.value}
							>
								{permission.name}
							</MenuItem>
						)}
					</Select>
				</FormControl>

			</DialogContent>

			<DialogActions>

				<Button
					disabled = {!this.isReadyToCreate()}
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onCreateUser === "function") {
							this.props.onCreateUser({
								name: this.state.name,
								email: this.state.email,
								password: this.state.password,
								permission: this.state.permission,
							})
						}
					}}
				>Создать</Button>

				<Button
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onCancel === "function") {
							this.props.onCancel()
						}
					}}
				>Отмена</Button>

			</DialogActions>

		</Dialog>

	}

}

export default CreateUserDialog
